import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Iconify from '../../../components/iconify';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';

import { toast } from 'react-toastify';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useBoolean } from '../../../hooks/use-boolean';
import usePopover from '../../../hooks/use-popover';
import { CommentDialog } from '../../../components/custom-dialog';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  dateFormat,
  GAME_STATUS,
  hasRole,
  permissions,
  PRIORITY,
  ROLE_IDS,
  timeFormat,
  UserPermissions,
} from '../../../utils/constant';
import { GlobalSearchContext } from '../../../context/GlobalSearchContext';
import moment from 'moment';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router';
import useCommonDetails from '../../../hooks/useCommonDetails';
import CommentBox from '../CommentBox';
import { formatDuration } from '../../../components/ClockInOutLog';
import { useSearchParams } from 'react-router-dom';
export interface Comment {
  role: string;
  name: string;
  comment: string;
  addedAt: string; // or Date if you prefer
}
export const getBackgroundColor = (role: any) => {
  switch (role) {
    case 3:
      return '#C4CDD5';
    case 1:
      return '#9CDBA6';
    case 4:
      return '#9CDBA6';
    case 2:
      return '#FEEFAD';
    default:
      return '#F4F6F8'; // Replace with your default color
  }
};
function GameTableRow(props: {
  row: any;
  isOpen: any;
  handleToggle: any;
  fetchPeriod: any;
  currentUserInfo: any;
  moderatorInfo: any;
  fetchGamesList: any;
}) {
  const {
    row,
    isOpen,
    handleToggle,
    fetchPeriod,
    currentUserInfo,
    fetchGamesList,
    moderatorInfo,
  } = props;

  const [searchParams] = useSearchParams();
  const surchIds = searchParams.get('gameId');
  const isDelay = searchParams.get('isDelay') === 'true';

  const [viewProtocolLinks, setProtocolLinks] = React.useState(
    row.protocolLinks
  );

  const navigate = useNavigate();
  const details = useCommonDetails();
  const [loadingProgress, setLoadingProgress] = React.useState(false);
  const [value, setValue] = useState<any>(null);
  const [QCValue, setQCValue] = useState<any>(null);
  const showProtocolLinks = useBoolean();
  const showVideo = useBoolean();
  const comment = useBoolean();
  const popover = usePopover();
  const { handleSearchChange, debouncedQuery, _searchQuery }: any =
    useContext(GlobalSearchContext);

  const [optionsMod, setOptionsMod] = useState<{ label: string; id: number }[]>(
    []
  );
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  useEffect(() => {
    if (surchIds && surchIds == row.gameId && isDelay) {
      comment.onTrue();
      popover.onClose();
    }
  }, [surchIds, isDelay, row.gameId, comment, popover]);
  useEffect(() => {
    const optdata = moderatorInfo?.map((el: any) => {
      return {
        label: el.name,
        id: el.id,
        middleName: el.middleName,
      };
    });
    setOptionsMod(optdata);
  }, [moderatorInfo]);
  useEffect(() => {
    if (row?.assignModeratorUser) {
      setValue({
        label: row?.assignModeratorUser?.name,
        id: row?.assignModeratorUser?.id,
        middleName: row?.middleName,
      });
    }
  }, [row?.assignModeratorUser]);
  useEffect(() => {
    if (row?.qcModeratorUser) {
      setQCValue({
        label: row?.qcModeratorUser?.name,
        id: row?.qcModeratorUser?.id,
        middleName: row?.qcModeratorUser,
      });
    }
  }, [row?.qcModeratorUser]);

  const moderatorChange = async (newValue: any, id: number, isQC?: boolean) => {
    try {
      let data = {};
      if (!isQC) {
        data = {
          assignId: newValue.id,
          gameId: id,
        };
      } else {
        data = {
          qcModerator: newValue.id,
          gameId: id,
        };
      }

      const response = await HttpService.post(API_ROUTES.assignModerator, data);

      fetchGamesList();
      if (!isQC) {
        toast.success('Moderator Assign Successfully', {
          position: 'bottom-right',
        });
      } else {
        toast.success('QC Moderator Assign Successfully', {
          position: 'bottom-right',
        });
      }
    } catch (error: any) {
      console.error('Error in Moderator Change : ', error);
    }
  };

  const updateStatus = async (event: any, id: string) => {
    try {
      const data = {
        new_value: event.target.value,
        old_value: row?.gameStatusTms,
        gameId: id,
        reason: 'MANUAL',
      };

      const response = await HttpService.patch(
        API_ROUTES.updateGameStatus,
        data
      );
      toast.success('Status Upadated Successfully', {
        position: 'bottom-right',
      });
      fetchGamesList();
    } catch (error: any) {
      console.error('Error updating status: ', error);
    }
  };

  const handleCheckDisable = (
    currentStatus: string,
    status: string,
    role: string,
    periods: Array<{ statusTms: string }>
  ) => {
    // Check if all statusTms in periods are "FINISHED"
    // const allPeriodsFinished = periods?.every(
    //   (period) => period.statusTms === 'FINISHED'
    // );

    // // Disable COMPLETED if not all statusTms are "FINISHED"
    // if (
    //   status === 'COMPLETED'
    //   // && !allPeriodsFinished                                 // uncomment this when you enable allPeriodsFinished this condition
    // ) {
    //   return true; // Disable COMPLETED
    // }

    // Check if any period.statusTms is NOT "TAGGING_COMPLETED" or "FINISHED"
    const hasIncompletePeriods = periods?.some(
      (period) =>
        period.statusTms !== 'TAGGING_COMPLETED' &&
        period.statusTms !== 'FINISHED'
    );

    // Disable IN_QC if role is "admin" or "moderator" and any period.statusTms is not TAGGING_COMPLETED or FINISHED
    if (
      hasRole(currentUserInfo.roleId, [
        ROLE_IDS.ADMIN,
        ROLE_IDS.SUPER_ADMIN,
        ROLE_IDS.MODERATOR,
      ]) &&
      status === 'IN_QC' &&
      hasIncompletePeriods
    ) {
      return true; // Disable IN_QC
    }

    // If the status is 'UNDER_REVIEW' or 'CANCELED', always enabled
    if (status === 'UNDER_REVIEW' || status === 'CANCELED') {
      return false;
    }

    // If the current status is '' and the user is an admin, all options are enabled
    if (
      currentStatus === '' &&
      hasRole(currentUserInfo.roleId, [ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN])
    ) {
      return status === 'CREATED'; // Enable all items for admins in  status
    }

    // For non-admin users or other statuses, apply the regular logic
    switch (currentStatus) {
      case 'CREATED':
        return status !== 'IN_PROGRESS'; // Only IN_PROGRESS is enabled
      case 'IN_PROGRESS':
        return status !== 'IN_QC'; // Only IN_QC is enabled
      case 'IN_QC':
        return status !== 'COMPLETED' && status !== 'QC_COMPLETE'; // Only COMPLETED is enabled
      case 'COMPLETED':
        return true; // All are disabled for non-admins in COMPLETED status
      default:
        return false; // Default: all enabled
    }
  };

  const processData = (data: any) => {
    return data
      ?.map((item: { status: any; total_seconds: number }) => {
        if (item.total_seconds === 0) {
          // Skip items with null end_time or total_seconds equal to 0
          return null;
        }

        // Convert total_seconds to milliseconds and format as HH:mm:ss
        const days = Math.floor(item.total_seconds / (3600 * 24));
        const hours = Math.floor((item.total_seconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((item.total_seconds % 3600) / 60);
        const seconds = Math.floor(item.total_seconds % 60);

        const daysStr = days > 0 ? `${days} Days ` : '';
        const hoursStr = hours.toString().padStart(2, '0');
        const minutesStr = minutes.toString().padStart(2, '0');
        const secondsStr = seconds.toString().padStart(2, '0');

        const formattedTime = `${daysStr}${hoursStr}:${minutesStr}:${secondsStr}`;

        return {
          status: item.status,
          time: formattedTime,
        };
      })
      .filter(Boolean); // Filter out any null values
  };

  const processedData = processData(row.statusElapsedTime);
  const [gameProgressTime, setGameProgressTime] = useState<any>([]);
  const [timerEl, setTimerEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(timerEl);
  const fetchGameProgressTime = async () => {
    try {
      const res = await HttpService.get(
        API_ROUTES.gameProgress.replace(':id', row?.gameId)
      );
      const data = res.data.data;

      const statusArray = Object.entries(data)
        .map(([key, value]) => ({
          key,
          value,
        }))
        .filter(
          (el: any) =>
            el.value && el.key !== 'COMPLETED' && el.key !== 'CANCELD'
        );

      setGameProgressTime(statusArray);
    } catch (error) {}
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setTimerEl(event.currentTarget);

    fetchGameProgressTime();
  };
  const handleClose = () => {
    setTimerEl(null);
  };
  const downloadFiles = async () => {
    try {
      setIsLoadingFile(true);

      const zip = new JSZip();
      let periodIndex = 1;

      const res = await HttpService.get(
        API_ROUTES.getDocument.replace(':id', row?.gameId)
      );
      const data = res.data.data;

      if (data.length === 0) {
        toast.error('Documents Not Available Yet !!!', {
          position: 'bottom-right',
        });
        return;
      }

      for (const period of data?.sort((a: any, b: any) =>
        a?.periodNo < b?.periodNo ? -1 : 1
      )) {
        const gameId = period.gameId;
        const documentsR = period.documents;
        for (const document of documentsR) {
          const docType = document.type === 1 ? 'shift' : 'event';

          if (!document.files || !Array.isArray(document.files)) {
            console.error('Invalid files data for document:', document);
            continue; // Skip to the next document
          }

          const sortedFiles = document.files.sort((a: any, b: any) =>
            a.createdAt < b.createdAt ? -1 : 1
          );

          for (let fileIndex = 0; fileIndex < sortedFiles.length; fileIndex++) {
            const file = sortedFiles[fileIndex];
            const filename = `${gameId}_${docType}_${periodIndex}per.csv`;

            try {
              const response = await fetch(file.Url);
              if (!response.ok) throw new Error(`Failed to fetch: ${file.Url}`);
              const blob = await response.blob();

              zip.file(filename, blob);
            } catch (fetchError) {
              console.error('Error fetching file:', fetchError);
            }
          }
        }

        periodIndex++;
      }

      zip
        .generateAsync({ type: 'blob' })
        .then((content) => {
          saveAs(content, `${row?.gameId || 'files'}.zip`);
          setIsLoadingFile(false);
        })
        .catch((zipError) => {
          console.error('Error generating zip:', zipError);
          setIsLoadingFile(false);
        });
    } catch (error) {
      console.error('Unexpected error:', error);
      setIsLoadingFile(false);
    }
  };

  const handleClickProgress = async () => {
    try {
      setLoadingProgress(true);
      const response = await HttpService.post(
        API_ROUTES.progressGame + `/${row.gameId}`
      );
      fetchPeriod();
      setLoadingProgress(response.data.data.totalPages);
    } catch (error: any) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoadingProgress(false);
    }
  };
  const handleNavigateToLog = (gameId: any) => {
    // Navigate to the UserDetailsUpdate page with the userId in the URL
    navigate(`/games/activity-log/${gameId}`);
  };

  const getSortedPeriods = (data: any) => {
    const currentTime = moment().valueOf();
    if (data.periods) {
      const filteredPeriods = data.periods
        .filter((period: any) => period.assign === details.userId)
        .map((period: any) => {
          const timeDifference =
            currentTime - moment(period.assignedAt).valueOf();
          const isWithinLast30Minutes = timeDifference <= 30 * 60 * 1000;
          return { ...period, isWithinLast30Minutes };
        })
        .sort(
          (a: any, b: any) =>
            moment(b.assignedAt).valueOf() - moment(a.assignedAt).valueOf()
        );
      return filteredPeriods[0];
    }
    return { ...data, periods: [] };
  };

  const sortedData = getSortedPeriods(row);
  const [commentText, setCommentText] = React.useState('');

  const addComment = async (rowId: string) => {
    if (!commentText.trim()) {
      console.warn('Comment cannot be empty.');
      return;
    }

    const newComment: Comment = {
      role: currentUserInfo.roleId || 'admin',
      name: currentUserInfo.name,
      comment: commentText,
      addedAt: new Date().toISOString(),
    };

    try {
      const existingComments: Comment[] = row?.comment || [];
      const updatedComments = [...existingComments, newComment];

      const data = {
        comment: updatedComments,
      };
      const response = await HttpService.patch(
        `${API_ROUTES.updateGameList}/${row.gameId}`,
        data
      );

      setCommentText(''); // Reset comment text
      fetchGamesList();
      toast.success('Comment Add Successfully', {
        position: 'bottom-right',
      });
    } catch (error: any) {
      console.error('Error updating comments:', error);
      setCommentText('');
    }
  };
  return (
    <>
      <TableRow
        sx={{
          backgroundColor: sortedData?.isWithinLast30Minutes
            ? 'lightblue'
            : 'transparent',
        }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleToggle(row.gameId)}
          >
            {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          {row.gameId}
          <Tooltip title="Copy Game ID">
            <IconButton
              onClick={() => {
                navigator.clipboard.writeText(row.gameId);
              }}
              size="small"
              sx={{ marginLeft: 1 }} // Add margin for spacing
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell>
          <Box
            sx={{
              background:
                {
                  MINOR: '#eeeeee',
                  NORMAL: '#dbf2ff',
                  MAJOR: '#eb6f33',
                  CRITICAL: '#d30584',
                  SHOW_STOPPER: '#e30000',
                }[PRIORITY[row.priority]] || '#ffffff', // Default to white if no match
              color: '#000',
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0 10px',
              borderRadius: 3,
              fontWeight: 600,
            }}
          >
            {PRIORITY?.[row?.priority]}
          </Box>
        </TableCell>
        <TableCell>
          {row?.game?.dateTime ? (
            <Stack direction={'column'}>
              <Typography variant="body2">
                {moment(row?.game?.dateTime).format(`${dateFormat}`)}
              </Typography>
              <Typography variant="body2">
                {moment(row?.game?.dateTime).format(`${timeFormat}`)}
              </Typography>
            </Stack>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell>
          <div>
            <span>{row?.game?.homeTeam?.nameEn}</span>
            <br />
            <span>{row?.game?.awayTeam?.nameEn}</span>
          </div>
        </TableCell>

        <TableCell align="left">
          {' '}
          <Tooltip title="Comments" placement="top" arrow>
            <IconButton
              onClick={() => {
                comment.onTrue();
                popover.onClose();
              }}
              disabled={hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])}
            >
              <Iconify icon="majesticons:comment-text-line" />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell align="left">
          {row?.createdAt ? (
            <Stack direction={'column'}>
              <Typography variant="body2">
                {moment(row?.createdAt).format(`${dateFormat}`)}
              </Typography>
              <Typography variant="body2">
                {moment(row?.createdAt).format(`${timeFormat}`)}
              </Typography>
            </Stack>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell align="left">
          {row?.lastStatusChangedAt ? (
            <Stack direction={'column'}>
              <Typography variant="body2">
                {moment(row?.lastStatusChangedAt).format(`${dateFormat}`)}
              </Typography>
              <Typography variant="body2">
                {moment(row?.lastStatusChangedAt).format(`${timeFormat}`)}
              </Typography>
            </Stack>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell
          align="left"
          sx={{
            margin: '0',
            padding: '15px 0',
            whiteSpace: 'nowrap',
          }}
        >
          <FormControl
            sx={{
              flexShrink: 0,
              width: { xs: 1, md: 150 },
              margin: '0 !important',
              padding: '0 !important',
              // fontWeight: '600 !important',
            }}
          >
            <Tooltip title={row?.gameStatusTms} arrow placement="top">
              <Select
                disabled={hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])}
                value={row?.gameStatusTms ? row?.gameStatusTms : ''}
                onChange={(event) => updateStatus(event, row.gameId)}
                sx={{
                  color: '#61677A',
                  backgroundColor: '#C4CDD5',
                  // fontWeight: '600 !important',
                  borderRadius: '50px',
                  height: '30px',
                  paddingLeft: '5px',
                  fontSize: '13px',
                  '& .MuiSvgIcon-root': {
                    color: '#61677A',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: { maxHeight: 240 },
                  },
                }}
              >
                {GAME_STATUS.map((status, ind: any) => (
                  <MenuItem
                    value={status}
                    key={ind}
                    disabled={handleCheckDisable(
                      row?.gameStatusTms,
                      status,
                      currentUserInfo.role,
                      row?.periods
                    )}
                    sx={{
                      color: '#61677A',
                    }}
                  >
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </Tooltip>
          </FormControl>
        </TableCell>

        <TableCell align="left">
          <Box sx={{ display: 'flex', gap: 2 }}>
            {row.videoLink ? (
              <>
                <Tooltip title="Watch Video" arrow placement="top">
                  <IconButton href={row.videoLink} target="_blank" size="small">
                    <VideoLibraryIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              'No Video'
            )}
            <Tooltip title="View Protocol Links" placement="top" arrow>
              <IconButton
                onClick={() => {
                  showProtocolLinks.onTrue();
                  popover.onClose();
                }}
              >
                <Iconify icon="carbon:view-filled" />
              </IconButton>
            </Tooltip>
            {Boolean(row?.isDocumentAvailable) &&
              (isLoadingFile ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <Tooltip title="Download All Files" placement="top" arrow>
                  <IconButton
                    onClick={() => {
                      downloadFiles();
                    }}
                    disabled={hasRole(currentUserInfo.roleId, [
                      ROLE_IDS.TAGGER,
                    ])}
                  >
                    <Iconify icon="mingcute:file-download-fill" />
                  </IconButton>
                </Tooltip>
              ))}
          </Box>
        </TableCell>

        <TableCell>
          <FormControl
            sx={{
              flexShrink: 0,
              width: { xs: 1, md: 210 },
              margin: '0 !important',
              padding: '0 !important',
              // fontWeight: '600 !important',
            }}
          >
            <Autocomplete
              size="small"
              options={optionsMod}
              id="disable-clearable"
              disableClearable
              onClose={() => {
                const data = {
                  target: {
                    value: '',
                  },
                };
                handleSearchChange(data);
              }}
              disabled={hasRole(currentUserInfo.roleId, [
                ROLE_IDS.TAGGER,
                ROLE_IDS.MODERATOR,
              ])}
              value={value} // Pass the value as an object
              onChange={(e, newValue: any) => {
                moderatorChange(newValue, row.gameId);
                // Set the selected option as the value
              }}
              renderOption={(props: any, option: any) => {
                return (
                  <Box component="li" {...props} key={option?.id}>
                    <Typography
                      variant="body1"
                      sx={{ fontStyle: 'normal', textTransform: 'none' }}
                    >
                      {UserPermissions[details.isDesabled]?.includes(
                        permissions.PARENTUSER
                      )
                        ? `${option?.label} (${option?.middleName})`
                        : option?.label}
                    </Typography>
                  </Box>
                );
              }}
              isOptionEqualToValue={(option, value) => option.id === value?.id} // Compare by id for selected item
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={debouncedQuery}
                  onChange={(e) => handleSearchChange(e)}
                  variant="outlined"
                  slotProps={{
                    input: {
                      ...params.InputProps,
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </TableCell>
        <TableCell>
          <FormControl
            sx={{
              flexShrink: 0,
              width: { xs: 1, md: 210 },
              margin: '0 !important',
              padding: '0 !important',
              // fontWeight: '600 !important',
            }}
          >
            <Autocomplete
              size="small"
              options={optionsMod}
              id="disable-clearable"
              disableClearable
              onClose={() => {
                const data = {
                  target: {
                    value: '',
                  },
                };
                handleSearchChange(data);
              }}
              disabled={hasRole(currentUserInfo.roleId, [
                ROLE_IDS.TAGGER,
                ROLE_IDS.MODERATOR,
              ])}
              value={QCValue} // Pass the value as an object
              onChange={(e, newValue: any) => {
                moderatorChange(newValue, row.gameId, true);
                // Set the selected option as the value
              }}
              renderOption={(props: any, option: any) => {
                return (
                  <Box component="li" {...props} key={option?.id}>
                    <Typography
                      variant="body1"
                      sx={{ fontStyle: 'normal', textTransform: 'none' }}
                    >
                      {UserPermissions[details.isDesabled]?.includes(
                        permissions.PARENTUSER
                      )
                        ? `${option?.label} (${option?.middleName})`
                        : option?.label}
                    </Typography>
                  </Box>
                );
              }}
              isOptionEqualToValue={(option, value) => option.id === value?.id} // Compare by id for selected item
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={debouncedQuery}
                  onChange={(e) => handleSearchChange(e)}
                  variant="outlined"
                  slotProps={{
                    input: {
                      ...params.InputProps,
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </TableCell>
        {!hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) && (
          <TableCell>
            <LoadingButton
              onClick={handleClickProgress}
              loading={loadingProgress}
              loadingPosition="start"
              startIcon={<RefreshIcon />}
              variant="text"
              sx={{ textTransform: 'none', color: '#680000' }}
            ></LoadingButton>
          </TableCell>
        )}

        <TableCell>
          {/* <Button
            variant="contained"
            size="small"
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={{ textTransform: 'none', width: '100px' }}
          >
            Status Timer
          </Button> */}

          <Tooltip title="Status Timer" placement="top" arrow>
            <IconButton
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <Iconify icon="gis:timer" />
            </IconButton>
          </Tooltip>

          <Menu
            id="basic-menu"
            anchorEl={timerEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {gameProgressTime?.length && gameProgressTime ? (
              gameProgressTime.map((item: any, index: any) => (
                <MenuItem onClick={handleClose} key={index}>
                  <p style={{ display: 'inline' }}>
                    <Typography
                      sx={{ display: 'inline', fontWeight: 600 }}
                      variant="body1"
                    >
                      Status:{' '}
                    </Typography>
                    {item.key}
                  </p>
                  &nbsp;
                  <p style={{ display: 'inline' }}>
                    <Typography
                      sx={{ display: 'inline', fontWeight: 600 }}
                      variant="body1"
                    >
                      Time:{' '}
                    </Typography>
                    {formatDuration(item.value)}
                  </p>
                </MenuItem>
              ))
            ) : (
              <Typography
                variant="body1"
                color="textSecondary"
                sx={{ padding: 2 }}
              >
                No Data
              </Typography>
            )}
          </Menu>
        </TableCell>
        <TableCell>
          <Tooltip title="Activity Log" placement="top" arrow>
            <IconButton
              onClick={() => {
                handleNavigateToLog(row.gameId);
              }}
            >
              <Iconify icon="carbon:view-filled" />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>

      <CommentBox
        data={row}
        isGame={true}
        comment={comment}
        gameData={row}
        commentText={commentText}
        setCommentText={setCommentText}
        addComment={addComment}
        isDelay={isDelay}
      />

      <CommentDialog
        open={showProtocolLinks.value}
        onClose={showProtocolLinks.onFalse}
        title="View Protocol Links"
        content={
          <TableContainer component={Paper}>
            <Table aria-label="Protocol Links table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Protocol Links</TableCell>
                </TableRow>
              </TableHead>
              {(viewProtocolLinks || []).length !== 0 ? (
                <TableBody>
                  {viewProtocolLinks?.map((protocolLinksData: any, id: any) => (
                    <TableRow
                      key={id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <>
                        <TableCell align="left">
                          {protocolLinksData ? (
                            <>
                              <a
                                href={protocolLinksData}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Protocol Links Data
                              </a>
                              <Tooltip title="Copy Protocol Link">
                                <IconButton
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      protocolLinksData
                                    );
                                  }}
                                  size="small"
                                  sx={{ marginLeft: 1 }} // Add margin for spacing
                                >
                                  <ContentCopyIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </>
                          ) : (
                            'No Protocol Links Data'
                          )}
                        </TableCell>
                      </>
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No Protocol Links Data
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        }
        action={
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              // addComment();
              showProtocolLinks.onFalse();
            }}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Add
          </Button>
        }
      />

      <CommentDialog
        open={showVideo.value}
        onClose={showVideo.onFalse}
        title="Video"
        content={
          <iframe
            width="100%" // Ensure it fits the dialog width
            height="400px"
            src={row.videoLink} // Pass the video link
            title="Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        }
        action={
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              // addComment();
              showVideo.onFalse();
            }}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Add
          </Button>
        }
      />
    </>
  );
}

export default GameTableRow;
